import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, } from '@angular/router';
import { tap } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';
import { CommonService } from '../services/common.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    @Inject(DOCUMENT) public document: Document,
    public authenticationService: AuthenticationService,
    public httpClient: HttpClient,
    public commonService:CommonService
    // private router: Router
  ){
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {

      // let user = JSON.parse(sessionStorage.getItem('userdata'));
      // let token = sessionStorage.getItem('token');
      // if(token && user.subcontractor_id){
      //   return true;
      // }
    //   this.router.navigateByUrl("/auth/login");
    // return false;

    // Return authenticated.
    if(this.commonService.isFranchisee) return true
    else return this.authenticationService.authenticate()
  }
}
